export function parseFeatureFlag(value: string | undefined, defaultValue = true): boolean {
  if (value === undefined || value.trim() === "") return defaultValue;
  const normalized = value.trim().toLowerCase();
  if (["true", "1", "yes", "on"].includes(normalized)) return true;
  if (["false", "0", "no", "off"].includes(normalized)) return false;
  return false;
}

export const managementUiEnabled = parseFeatureFlag(import.meta.env.VITE_MANAGEMENT_UI_ENABLED);
export const playerEnabled = parseFeatureFlag(import.meta.env.VITE_PLAYER_ENABLED);
export const menuEnabled = parseFeatureFlag(import.meta.env.VITE_MENU_ENABLED);
